import {flatMap, reduce} from 'lodash';
import {Interval} from 'luxon';

import {computeIsValidInterval} from '../../../../../libs/shared/core/src/helpers/datetime/luxonHelpers';
import {
  buildIntervalFromRepeatingAvailabilityBlock,
  buildRepeatingAvailabilityBlockFromInterval,
} from '../../../../helpers/models/schedulingLinkAvailabilityHelpers';
import {SchedulingLinkRepeatingAvailabilityBlockModel} from '../../../../models/api/schedulingLinkModel';

/*
 * Api.
 */

export function toggleRepeatingAvailabiltyBlocks(
  selectedBlocks: ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel>,
  blocksToToggle: ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel>,
): ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel> {
  return reduce(
    blocksToToggle,
    (currentSelectedBlocks, blockToToggle) =>
      toggleRepeatingAvailabiltyBlock(currentSelectedBlocks, blockToToggle),
    selectedBlocks,
  );
}

export function toggleRepeatingAvailabiltyBlock(
  selectedBlocks: ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel>,
  blockToToggle: SchedulingLinkRepeatingAvailabilityBlockModel,
): ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel> {
  const intervalToToggle = buildIntervalFromRepeatingAvailabilityBlock(blockToToggle);
  const selectedIntervals = selectedBlocks.map(buildIntervalFromRepeatingAvailabilityBlock);

  // Add the intervals that don't overlap with the existing intervals.
  const intervalsToAdd = intervalToToggle.difference(...selectedIntervals);

  // Remove the existing intervals that overlap with the interval to toggle.
  const selectedIntervalsWithOverlapRemoved = flatMap(selectedIntervals, (interval) => {
    // Remove parts that intersect with the new interval.
    const intersection = interval.intersection(intervalToToggle);
    if (!intersection) {
      return interval;
    }

    return interval.difference(intersection);
  });

  const newSelectedIntervals = Interval.merge([...selectedIntervalsWithOverlapRemoved, ...intervalsToAdd]);
  return newSelectedIntervals.filter(computeIsValidInterval).map(buildRepeatingAvailabilityBlockFromInterval);
}
